
















import { Employe, VehiculeType } from "../../models/Employe";
import RadioButtons from "../../core/Forms/RadioButtons.vue";
import TextInput from "../../core/Forms/TextInput.vue";

export default {
    name: "VehiculeEdit",
    components: { TextInput, RadioButtons },
    props: {
        vehicule: Employe.Vehicule,
    },
    data() {
        return {
            vehiculeTypes: Employe.VehiculeType,
        };
    },
};
